import { Avatar, Box, Button, Card, Stack, Typography } from "@mui/material";
import React from "react";
import GetAppIcon from "@mui/icons-material/GetApp";
import { BASE_URL } from "../../../api/axios";
import ModuleIconBadge from "../../../components/ModuleIconBadge";

// A downloadable tool hosted on SharePoint. Shows the tool's own image when
// it has one, otherwise the Software badge.
const SharepointSoftwareCard = ({ title, imagePath, description, link }) => {
  return (
    <Card
      sx={{
        height: "100%",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        {imagePath ? (
          <Avatar
            variant="rounded"
            alt={title}
            src={`${BASE_URL}/${imagePath}`}
            sx={{ width: 44, height: 44 }}
          />
        ) : (
          <ModuleIconBadge moduleKey="software" size="lg" />
        )}
        <Typography variant="subtitle1" fontWeight={700}>
          {title}
        </Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
        {description}
      </Typography>
      <Box>
        <Button
          variant="contained"
          size="small"
          startIcon={<GetAppIcon />}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download
        </Button>
      </Box>
    </Card>
  );
};

export default SharepointSoftwareCard;
